module.exports = __webpack_public_path__ + "static/media/pro-1.83ff8b7e.jpg";